// Здесь приходится использовать require и module.export,
// т.к. используется в webpack.config.js
// и нельзя использовать es6
let bemCnLite = require('bem-cn-lite');
const prefix = require('./prefix');

/**
 * Возвращает инстанс bem-cn для использования в компонентах. Генерирует классы с учетом префикса
 * @param {string} name Имя блока без учета префиксов
 */
module.exports = function getClassName(name) {
    if (typeof bemCnLite !== 'function') {
        bemCnLite = bemCnLite.default;
    }
    // хак для Grid
    if (name.match(/^kitt-/)) {
        return bemCnLite(name);
    }
    if (name.match(/^{prefix}-/)) {
        return bemCnLite(name);
    }
    return bemCnLite(`${prefix}-${name}`);
};
